export default __webpack_public_path__ + "static/media/terrible.8f9f5c9b.svg";